import CallsPerDayChart from "./CallsPerDayChart";
import DurationChart from "./DurationChart";
import OutcomesChart from "./OutcomesChart";
import LeadTaskChart from "./LeadTaskChart";
import EmptyState from "../common/EmptyState";

function hasSeriesData(values = []) {
  return values.some((value) => Number(value || 0) > 0);
}

export default function AnalyticsCharts({
  callSeries,
  durationSeries,
  outcomeSeries,
  leadTaskSeries,
}) {
  const hasCallsPerDay = hasSeriesData(callSeries.values);
  const hasDurationData = hasSeriesData(durationSeries.values);
  const hasOutcomeData = hasSeriesData(outcomeSeries.values);
  const hasLeadTaskData = hasSeriesData(leadTaskSeries.values);

  return (
    <div className="tab-panel active" id="panel-analytics" role="tabpanel">
      <div className="section-title">Call Analytics</div>
      <div className="charts-grid">
        <div className="chart-card">
          <div className="chart-title">Calls Per Day (Last 14 Days)</div>
          {hasCallsPerDay ? (
            <CallsPerDayChart
              labels={callSeries.labels}
              values={callSeries.values}
            />
          ) : (
            <EmptyState
              title="No call data available"
              subtitle="Daily call activity will appear here."
            />
          )}
        </div>
        <div className="chart-card">
          <div className="chart-title">Duration Distribution</div>
          {hasDurationData ? (
            <DurationChart
              labels={durationSeries.labels}
              values={durationSeries.values}
            />
          ) : (
            <EmptyState
              title="No duration data available"
              subtitle="Call duration patterns will appear here."
            />
          )}
        </div>
        <div className="chart-card">
          <div className="chart-title">Call Outcomes</div>
          {hasOutcomeData ? (
            <OutcomesChart
              values={outcomeSeries.values}
              total={outcomeSeries.total}
            />
          ) : (
            <EmptyState
              title="No outcomes available"
              subtitle="Call outcome breakdown will appear here."
            />
          )}
        </div>
        <div className="chart-card">
          <div className="chart-title">Lead Task Distribution</div>
          {hasLeadTaskData ? (
            <LeadTaskChart
              labels={leadTaskSeries.labels}
              values={leadTaskSeries.values}
              colors={leadTaskSeries.colors}
              total={leadTaskSeries.total}
            />
          ) : (
            <EmptyState
              title="No lead task data available"
              subtitle="Lead task distribution will appear here."
            />
          )}
        </div>
      </div>
    </div>
  );
}
